<template>
  <div class="h5Uninitialized h5content">
    <div class="topDescription">
      <div>需要先绑定您在蓝莓象(HIS)系统的账号方可使用此功能</div>
      <div>绑定入口：蓝莓象 -> 个人信息 -> 企微账号</div>
    </div>

    <div class="steps">
      <div class="step">
        <div class="stepText">
          <span>① 电脑登录蓝莓象系统，点击头像，选择</span>
          <span class="font-333"> 个人信息</span>
        </div>
        <div class="stepImageBox">
          <van-image
            class="stepImage"
            :src="tipsImage.step1"
            fit="contain"
            @click="previewImage(0)"
          />
        </div>
      </div>

      <div class="step">
        <div class="stepText">
          ②选择<span class="font-333"> 企微账号 </span>关联页面
        </div>
        <div class="stepImageBox">
          <van-image
            class="stepImage"
            :src="tipsImage.step2"
            fit="contain"
            @click="previewImage(1)"
          />
        </div>
      </div>
    </div>

    <div class="refreshText">
      已在蓝莓象（HIS）中完成绑定？<span
        class="refreshBtn"
        @click="refreshBtnClick"
        >点此刷新</span
      >
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import { showImagePreview } from "vant";
import step1 from "@/assets/img/bindTips/step1.png";
import step2 from "@/assets/img/bindTips/step2.png";

export default {
  name: "h5Uninitialized",
  components: {
    VanImage,
  },
  data: function () {
    return {
      tipsImage: {
        step1,
        step2,
      },
    };
  },
  methods: {
    //刷新页面
    refreshBtnClick() {
      this.$router.go(-1); // 返回上一页
      setTimeout(function () {
        window.location.reload(); // 刷新页面
      }, 500);
    },
    //预览图片
    previewImage(index) {
      showImagePreview({
        images: [this.tipsImage.step1, this.tipsImage.step2],
        startPosition: index,
      });
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.h5Uninitialized {
  //兼容PC端显示宽度，移动端很少有宽度800px的屏幕
  max-width: 800px;
  margin: 0 auto;
  font-size: 0.292rem;
  color: #666;
  line-height: 2;
  text-align: left;
}

.topDescription {
  padding-top: 0.333rem;
}

.steps {
  margin-top: 0.333rem;
}

.step {
  width: 100%;
  margin-bottom: 0.333rem;
}

.stepText {
  line-height: 1.6;
  margin-bottom: 0.208rem;
}

.stepImageBox {
  width: 100%;
  margin: 0;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .stepImage {
    width: 100%;
  }
}

.refreshText {
  margin-top: 0.333rem;
  text-align: center;
  color: #333;

  .refreshBtn {
    color: #28b8c3;
    cursor: pointer;
    text-align: center;
  }
}
</style>
